import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Shield, Loader2, AlertCircle } from "lucide-react";
import SheetCanvas from "@/components/sheet/SheetCanvas";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SharedSheet() {
  const { token } = useParams();
  const [snapshot, setSnapshot] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    axios.get(`${BACKEND_URL}/api/shared/${token}`)
      .then((res) => { if (!cancelled) setSnapshot(res.data); })
      .catch(() => { if (!cancelled) setError("This shared link is invalid or has been removed."); });
    return () => { cancelled = true; };
  }, [token]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#070A11] text-[#A0ABC0]">
        <div className="max-w-md text-center">
          <AlertCircle className="mx-auto h-8 w-8 text-[#D4AF37]" />
          <p className="mt-4 text-sm">{error}</p>
          <Link to="/" className="mt-6 inline-block text-sm text-[#D4AF37] hover:underline">Go to RPGme</Link>
        </div>
      </div>
    );
  }

  if (!snapshot) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#070A11] text-[#A0ABC0]">
        <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Loading shared sheet…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#070A11] text-white" data-testid="shared-sheet-page">
      <header className="flex flex-wrap items-center justify-between gap-3 border-b border-[#212A3E] bg-[#0a0f1c] px-6 py-4">
        <div className="flex items-center gap-3">
          <Shield className="h-5 w-5 text-[#D4AF37]" />
          <div>
            <div className="font-serif-display text-xl text-white" data-testid="shared-sheet-title">
              {snapshot.name || "Untitled"}
            </div>
            <div className="font-mono-tight text-[10px] uppercase tracking-[0.18em] text-[#A0ABC0]">
              Read-only snapshot · shared via RPGme
            </div>
          </div>
        </div>
        <Link
          to="/"
          className="rounded-md border border-[#212A3E] bg-transparent px-4 py-2 text-xs uppercase tracking-[0.14em] text-[#D4AF37] hover:border-[#D4AF37]/60"
          data-testid="shared-sheet-cta"
        >
          Build your own → RPG<span className="text-white">me</span>
        </Link>
      </header>

      <div className="px-4 py-6">
        <SheetCanvas sheet={snapshot} onChange={() => {}} readOnly shareToken={token} />
      </div>

      <footer className="px-6 py-6 text-center text-[10px] uppercase tracking-[0.2em] text-[#A0ABC0]/60">
        Shared via RPGme · It's your life. Be the main character.
      </footer>
    </div>
  );
}
